import {createApp} from 'vue';
import formCreate from '@form-create/element-ui';
import formCreateElAutoImport from '@form-create/element-ui/auto-import';
import { patchFormCreateFrame } from '@/libs/patch-form-create-frame';

import Cookies from 'js-cookie';

// tailwindcss
import './index.css';

import '@/assets/styles/index.scss';

import { ElImage, ElMessage, ElMessageBox, ElNotification, ElLoading, ElInfiniteScroll, provideGlobalConfig } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
// element css
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/loading/style/css';
import 'element-plus/es/components/table/style/css';
import 'element-plus/es/components/input/style/css';
import 'element-plus/es/components/input-number/style/css';
import 'element-plus/es/components/select/style/css';


import '@/styles/index.scss';
import '@/styles/element-plus-override.scss';
import uploadFrom from "@/components/uploadPictures/uploadFrom/index";
import guidancePop from "@/components/guidancePop/index.vue";
import { modalSure ,modalSureDelete} from "@/libs/public";
import modalForm from "@/libs/modal-form";
import modalAttr from "@/libs/modal-attr";
import videoCloud from "@/utils/videoCloud";

//iconfont
import '@/styles/iconfont/iconfont.css';
import '@/styles/iconfontYI/iconfontYI.css';
import '@/styles/crmeb_one/index.scss';


import App from './App.vue';
import store from './store';
import router from './router';
import directive from './directive'; // directive

import moment from 'moment'

moment.locale('zh-cn')// 使用中文时间

// 注册指令
import plugins from './plugins';
import crmebAuth from '@/plugins/crmebAuth';
import {download} from '@/api/request';

// svg图标
import 'virtual:svg-icons-register';
import SvgIcon from '@/components/SvgIcon/index.vue';
import elementIcons from '@/components/SvgIcon/svgicon';

import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// 处理从管理后台转跳时的 token（通过 URL 参数传递）
// 解决跨域 Cookie 问题：从 localhost:8081 设置的 Cookie 无法被 localhost:8082 读取
// 注意：必须在 permission.ts 之前执行，确保 token 在路由守卫检查之前被设置
import { setToken, getToken } from '@/utils/auth';
import { startNotice } from '@/libs/notice';

// 检测 URL 中的 token 参数并设置到本地 Cookie（解决跨域 Cookie 问题）
const urlParams = new URLSearchParams(window.location.search);
const tokenFromUrl = urlParams.get('token');
if (tokenFromUrl) {
  // 如果 URL 中有 token 参数，设置到本地 Cookie
  setToken(tokenFromUrl);
  // 移除 URL 中的 token 参数，避免泄露
  urlParams.delete('token');
  const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
  window.history.replaceState({}, '', newUrl);
}

const token = getToken();
if (token) {
  startNotice(token);
}

import './permission'; // permission control（必须在 token 处理之后）

/* 表头覆盖必须最后加载（晚于 ele 按需 table 样式） */
import '@/styles/table-header-override.scss';

//缓存监听
import {dispatchEventStorage} from '@/utils/watchLocalStorage'
import { installMessageGuard } from '@/utils/expand/messageGuard';

const app = createApp(App);

// 全局方法挂载
app.config.globalProperties.download = download;

app.config.globalProperties.$modalSure = modalSure;
app.config.globalProperties.$modalForm = modalForm ;
app.config.globalProperties.$modalAttr = modalAttr;
app.config.globalProperties.$modalSureDelete = modalSureDelete;
app.config.globalProperties.$crmebAuth = crmebAuth;
app.config.globalProperties.$videoCloud = videoCloud;
(window as any).$videoCloud = videoCloud;

app.use(VueViewer, {
    defaultOptions: {
        zIndex: 9999
    }
})
// TITA 扩展：EP 图片预览默认不 teleport，表格 sticky/fixed 列会盖住大图，与页面混合。对齐 EB 全屏预览。
const previewTeleportedProp = ElImage.props?.previewTeleported as { default?: boolean } | undefined;
if (previewTeleportedProp) {
  previewTeleportedProp.default = true;
}
// Element Plus 中文（日期时间选择器：周几 / 此刻 / 确定 等）
// Element Plus 按需：组件由 unplugin-vue-components(ElementPlusResolver) 解析；此处只注册服务/指令（$message/$msgbox/$notify/$loading/v-loading/v-infinite-scroll）
installMessageGuard();
app.use(ElMessage);
app.use(ElMessageBox);
app.use(ElNotification);
app.use(ElLoading);
app.use(ElInfiniteScroll);
// 等价原 app.use(ElementPlus, {...}) 的全局配置（写入 app provides + 服务全局配置；独立 createApp 的上传弹层复制 provides 后同样生效）
provideGlobalConfig({ size: 'default', zIndex: 3000, locale: zhCn }, app, true);
app.use(router);
app.use(store);
app.use(plugins);
app.use(elementIcons);
formCreate.component('guidancePop', guidancePop);
// form-create 所需 EP 组件（原依赖全量注册）
formCreate.use(formCreateElAutoImport);
app.use(formCreate);
// fc-frame 选用户/选图：about:blank 阶段写入的 helper 会在页面加载后丢失
patchFormCreateFrame();
app.use(uploadFrom);
app.component('guidancePop', guidancePop);
app.use(dispatchEventStorage)
app.component('svg-icon', SvgIcon);

directive(app);
app.mount('#app');
